import { IPerson } from '../../../services/person.service';
import { IStaff } from '../../../services/staff.service';
class StaffListController {

    private staff: IStaff[];
    
    constructor() {
        "ngInject";
    }
}

export const staffListComponent: ng.IComponentOptions = {
    bindings: {
        staff : "<"
    },
    controller : StaffListController,
    template : require("./staff.list.html")
};



// WEBPACK FOOTER //
// ./src/app/modules/settings/staff/staff.list.component.ts